export default {
  key: 'Bb',
  suffix: 'mmaj11',
  positions: [{
    frets: '5354',
    fingers: '3142'
  }, {
    frets: '6353',
    fingers: '4131',
    barres: 3,
    capo: true
  }, {
    frets: '6986',
    fingers: '1431',
    barres: 6,
    capo: true
  }]
};